<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container-fluid">
        <router-link class="navbar-logo d-flex align-items-center" to="/">
          <img src="/logo-white.png" alt="Publibou Logo" class="logo" />
        </router-link>
        
        <router-link class="navbar-brand d-flex align-items-center" to="/">
          <img v-if="theme.logoUrl" :src="theme.logoUrl" alt="Logo" class="navbar-logo me-2">
        </router-link>
        <UserMenu />
      </div>
    </nav>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
import UserMenu from './components/UserMenu.vue';
import { theme } from '@/store/theme';
import { watch, onMounted, computed } from 'vue';
import { userStore } from '@/store/userStore';
import { notificationStore } from '@/store/notificationStore';

export default {
  name: 'App',
  components: {
    UserMenu,
  },
  setup() {
    const applyTheme = () => {
      document.documentElement.style.setProperty('--bs-primary', theme.primaryColor);
      document.documentElement.style.setProperty('--bs-secondary', theme.secondaryColor);
    };

    // Watch for theme changes and apply them as CSS variables
    watch(() => theme.primaryColor, applyTheme);
    watch(() => theme.secondaryColor, applyTheme);

    // Apply theme on component mount as well
    onMounted(async () => {
      applyTheme();
      await userStore.loadCurrentUser();
      if (userStore.currentUser) {
        notificationStore.fetchNotifications();
        notificationStore.initSocket(userStore.currentUser.id);
      }
    });

    // Computed property to determine navbar text color (light or dark) based on background brightness
    const navbarClass = computed(() => {
      try {
        const color = theme.primaryColor;
        if (!color) return 'navbar-dark'; // Default for safety

        // Simple check for named colors that are light
        if (['white', 'yellow', 'lime', 'aqua', 'silver'].some(lightColor => color.toLowerCase().includes(lightColor))) {
            return 'navbar-light';
        }

        // Convert hex to RGB
        let r, g, b;
        if (color.startsWith('#')) {
          let hex = color.slice(1);
          if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
          }
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        } else if (color.startsWith('rgb')) {
          const parts = color.match(/(\d+)/g);
          [r, g, b] = parts.map(Number);
        } else {
          return 'navbar-dark'; // Fallback for unknown formats
        }

        // Calculate luma (perceived brightness)
        const luma = 0.299 * r + 0.587 * g + 0.114 * b;

        // Use light text on dark backgrounds, and dark text on light backgrounds
        return luma > 128 ? 'navbar-light' : 'navbar-dark';
      } catch (e) {
        console.error('Could not parse color for navbar class:', theme.primaryColor, e);
        return 'navbar-dark'; // Fallback
      }
    });

    return {
      theme,
      navbarClass,
    };
  },
};
</script>

<style>
/* You can add global styles here if needed */
:root {
  --background-gradient: linear-gradient(135deg, #1683b8 0%, #3aaee8 100%);
  --background: #0a97e5;
  --background-hover : #39b3f6;
  --btn-border-color: #0b95d2fc;
}

body {
  background-color: #f8f9fa;
}

#app .navbar {
   background: var(--background);
   padding: 5px 0;
   height: 40px;

  .navbar-logo {
    padding: 0;
  }

  .navbar-brand {
    padding: 0;
    margin: 0;
    margin-left: 20px;

    img {
      height: 30px;
      width: auto;
      margin: 0 !important;
      padding: 0;
      align-items: center;
      align-content: center;
      align-self: center;
    }
  }

  .logo {
    height: 30px;
    width: auto;
  }
}

/* Composant vue-zoomable */
#v-zoomable-control-btns {
  display: none;
}
</style>
